import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeUrlPipe } from '../../../../modules/fwcore';
import { ModalWrapperComponent } from '../../../widgets/components';
import { ModalOptions } from '../../../widgets/models';

@Component({
  selector: 'app-whiteboard-view',
  standalone:true,
  imports: [ModalWrapperComponent, SafeUrlPipe],
  templateUrl: './whiteboard-view.component.html',
  styleUrls: ['./whiteboard-view.component.scss']
})
export class WhiteboardViewComponent implements OnInit {  
  @Input() options: ModalOptions = new ModalOptions();
  @Input() params: any[] = [];
  whiteboardUrl: string = "";

  constructor(private modal: NgbActiveModal) { }


  ngOnInit(): void {
    if (this.params) {
      this.whiteboardUrl = "https://miro.com/app/live-embed/" + this.params[0] + "?embedAutoplay=true&moveToViewport=-23165,-5837,13803,7546";
    }
  }

  
  public onCancel() {
    this.modal.dismiss('Cancelled');
  } 
}


